import React from "react";
// @Mui
import { alpha, Box, Stack, Typography } from "@mui/material";
//
import Iconify from "../Iconify";
import getContrastTextColor from "src/utils/getContrastColor";

// --------------------------------------------------------------------

function ToastContent({ data }) {
  const { content, icon, color } = data;

  return (
    <Box
      sx={{
        px: 2,
        minHeight: 60,
        py: 1,
        bgcolor: color,
        width: "100%",
        borderRadius: 4,
      }}
    >
      <Stack direction="row" alignItems="center" gap={2}>
        <Box
          sx={{
            bgcolor: getContrastTextColor(color),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 1,
            borderRadius: "99%",
          }}
        >
          <Iconify icon={icon} sx={{ width: 25, height: 25, color: color }} />
        </Box>
        <Typography color={getContrastTextColor(color)} variant="subtitle2">
          {content}
        </Typography>
      </Stack>
    </Box>
  );
}

export default ToastContent;
